import { Component, ChangeDetectionStrategy } from '@angular/core';
import { LibTableComponent } from 'tuain-ng-forms-lib';

@Component({
  selector: 'app-chart-table',
  templateUrl: './app-chart-table.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})

export class AppChartTableComponent extends LibTableComponent {
  public chartOptions: any;
  public chartLabels: string[];
  public chartType: string;
  public chartLegend: boolean;
  public chartData: any[];

  override start(): void {
    this.updateTableData();
  }

  override updateTableData() {
    this.chartLegend = true;
    this.chartType = this.table?.getCustomAttribute('chartType').toString() ?? 'bar';
    this.chartOptions = this.table?.getCustomAttribute('chartOptions')
      ?? { scaleShowVerticalLines: false, responsive: true };
    if (!this.table?.columns || !Array.isArray(this.table?.columns) || this.table?.columns.length < 1) {
      return;
    }
    this.chartData = [];
    this.chartLabels = [];
    for (let rowIndex = 0; rowIndex < this.visibleRecords?.length; rowIndex++) {
      const { recordData } = this.visibleRecords[rowIndex];
      const recordLabel = recordData?.[this.table?.columns?.[0]?.fieldCode] ?? '';
      this.chartLabels.push(recordLabel);
    }
    for (let colIndex = 1; colIndex < this.table?.columns?.length; colIndex++) {
      const { fieldTitle, visible, fieldCode } = this.table?.columns[colIndex];
      if (!visible) { continue; }
      const data = [];
      for (let rowIndex = 0; rowIndex < this.visibleRecords?.length; rowIndex++) {
        const { recordData } = this.visibleRecords[rowIndex];
        data.push(+recordData[fieldCode]);
      }
      this.chartData.push({ data, label: fieldTitle });
    }
  }
}
